export const getMethods = instance => {
  const prototype = Object.getPrototypeOf(instance);
  
  return (
    Object
      .getOwnPropertyNames(prototype)
      .filter( name => name !== 'constructor' )
  )
};


// WEBPACK FOOTER //
// ./src/Services/Misc/methods.js